import { Link, navigate } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import renderLink from '~/utils/render-link';

const Sidebar = styled.div`
  .is-active .sidebar__checkbox {
    ${tw`border-blue bg-blue`}
  }
`;

export default function SidebarFilter({ pageName, heading, items, className = '' }) {
  return (
    <Sidebar className={`mb-16 ${className}`}>
      <h4 className="text-17px font-semibold opacity-50 uppercase mb-2 sm:mb-3">{heading}</h4>
      <div className="sm:hidden">
        <select
          className="w-full bg-black text-white border-b border-white h-10"
          onChange={({ target: { value } }) => navigate('/' + value)}
        >
          {items.map(({ uuid, name, full_slug }) => (
            <option selected={pageName === name} key={`mobile${name}`} value={full_slug}>
              {name}
            </option>
          ))}
        </select>
      </div>
      <div className="text-15px font-semibold hidden sm:block">
        {items.map(({ uuid, name, full_slug }) => (
          <div key={uuid} className="mb-1">
            <Link
              to={renderLink('/' + full_slug)}
              activeClassName="is-active"
              className="group inline-flex items-center -ml-3 cursor-pointer select-none"
            >
              <div className="pl-3">
                <div
                  className={`h-[12px] w-[12px] border transition-colors ease-in-out border-white rounded-full sidebar__checkbox`}
                />
              </div>
              <div className={`pl-3 opacity-50 transition-opacity duration-300 ease-in-out group-hover:opacity-100`}>
                {name}
              </div>
            </Link>
          </div>
        ))}
      </div>
    </Sidebar>
  );
}
